<!-- todo -->
<template>
    <v-form
        ref="form"
        v-model="form.valid"
        lazy-validation
    >
        <v-card>
            <v-card-title>
                <v-subheader>{{ $t('portfolios.teamMember.form.data') }}</v-subheader>
                <v-spacer></v-spacer>
                <v-btn
                    large
                    color="primary"
                    :disabled="!form.valid"
                    @click.native="save(formMethod)"
                    v-show="!form.loading"
                >{{ $t('common.save') }}</v-btn>
            </v-card-title>

            <v-divider></v-divider>

            <v-progress-linear :indeterminate="true" v-show="form.loading"></v-progress-linear>

            <v-card-text v-show="!form.loading">
                <v-container>
                    <v-row>
                        <v-col cols="12" md="2" class="text-center">
                            <input-avatar :setup.sync="form.inputAvatar"></input-avatar>
                        </v-col>
                        <v-col cols="12" md="10">
                            <v-row>
                                <v-col cols="12" :class="[(form.isEdit) ? 'col-md-6' : 'col-md-4']">
                                    <v-text-field
                                        v-model="user.name"
                                        :rules="form.rules.name"
                                        :label="$t('portfolios.teamMember.form.name.label')"
                                        required
                                        filled
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" :class="[(form.isEdit) ? 'col-md-6' : 'col-md-4']">
                                    <v-text-field
                                        v-model="user.username"
                                        :rules="form.rules.email"
                                        :label="$t('portfolios.teamMember.form.username.label')"
                                        required
                                        filled
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field
                                        v-model="userCompany.profile.jobTitle"
                                        :rules="form.rules.jobTitle"
                                        :label="$t('portfolios.teamMember.form.jobTitle.label')"
                                        required
                                        filled
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field
                                        v-model="form.fieldMasks.phone"
                                        :rules="form.rules.phone"
                                        :label="$t('portfolios.teamMember.form.phone.label')"
                                        v-mask="['(##) ####-####', '(##) #####-####']"
                                        required
                                        filled
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="3" md="3">
                                    <div class="d-flex align-center input-height">
                                        <span class="mr-1">{{ $t('portfolios.teamMember.form.pickColor') }}</span>
                                        <swatches
                                            v-model="userCompany.profile.color"
                                            popover-to="left"
                                            show-fallback
                                            fallback-input-type="color"
                                        ></swatches>
                                    </div>
                                </v-col>
                                <v-col cols="4" md="3">
                                    <div class="d-flex align-center input-height">
                                        <v-switch
                                            flat
                                            inset
                                            v-model="userCompany.permissions.isAdmin"
                                            :label="$t('portfolios.teamMember.form.mainAccount.label')"
                                        ></v-switch>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-title>
                <v-spacer></v-spacer>
                <v-btn
                    large
                    color="primary"
                    :disabled="!form.valid"
                    @click.native="save(formMethod)"
                    v-show="!form.loading"
                >{{ $t('common.save') }}</v-btn>
            </v-card-title>
        </v-card>
    </v-form>
</template>

<script>
import API from '@/api'
import InputAvatar from '@/components/InputAvatar'
import Swatches from 'vue-swatches'
import { mask } from 'vue-the-mask'

export default {
    name: 'form-staff',
    metaInfo () {
        return {
            title: this.$t('portfolios.teamMember.form.meta.title'),
            meta: [
                { name: 'description', content: this.$t('portfolios.teamMember.form.meta.description') },
                { name: 'keywords', content: this.$t('portfolios.teamMember.form.meta.keywords') }
            ]
        }
    },
    components: {
        InputAvatar,
        Swatches
    },
    directives: {
        mask
    },
    data: function () {
        return {
            form: {
                isEdit: false,
                valid: false,
                rules: {
                    name: [
                        v => !!v || this.$t('portfolios.teamMember.form.name.required'),
                        v => (v && v.length >= 3) || this.$t('portfolios.teamMember.form.name.length')
                    ],
                    jobTitle: [
                        v => !!v || this.$t('portfolios.teamMember.form.jobTitle.required'),
                        v => (v && v.length >= 3) || this.$t('portfolios.teamMember.form.jobTitle.length')
                    ],
                    username: [
                        v => !!v || this.$t('portfolios.teamMember.form.username.required'),
                        v => /.+@.+/.test(v) || this.$t('portfolios.teamMember.form.username.test')
                    ],
                    phone: [
                        v => !!v || this.$t('portfolios.teamMember.form.phone.required'),
                        v => (v && v.length >= 8) || this.$t('portfolios.teamMember.form.phone.length')
                    ]
                },
                loading: true,
                inputAvatar: {
                    dirty: false,
                    img: undefined,
                    name: undefined,
                    color: '#2980b9',
                    placeholder: 'Avatar',
                    file: undefined
                },
                fieldMasks: {
                    phone: undefined
                }
            },
            user: {
                objectId: undefined,
                name: undefined,
                username: undefined
            },
            userCompany: {
                user: undefined,
                client: undefined,
                profile: {
                    color: '#2980b9',
                    phone: undefined,
                    jobTitle: undefined
                },
                nameLowerCase: undefined,
                permissions: {
                    isEmployee: true,
                    isAdmin: false
                }
            }
        }
    },
    watch: {
        'userCompany.profile.avatar': {
            handler: function (val, oldVal) {
                if (oldVal !== val && val !== undefined) {
                    this.form.inputAvatar.img = (val.url === undefined) ? undefined : val.url
                }
                this.form.inputAvatar.name = this.user.name
                this.form.inputAvatar.color = this.userCompany?.profile.color
            },
            deep: true
        },
        'userCompany.profile.color': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.form.inputAvatar.color = this.userCompany?.profile.color
                }
            },
            deep: true
        }
    },
    mounted () {
        if (this.$route.params.id != null) {
            this.loadData()
        } else {
            this.form.loading = false
        }
    },
    computed: {
        formMethod () {
            return (this.$route.params.id != null)
        }
    },
    methods: {
        checkIsOwner () {
            const profile = JSON.parse(localStorage.profile)
            return (this.$route.params.id === profile.objectId)
        },
        loadData () {
            const endpoint = API.EndPoints.getUserCompanyDetail
            endpoint.id = this.$route.params.id
            const params = {
                include: ['user']
            }
            return new API(endpoint, params).request().then(response => {
                const data = response.body
                this.userCompany = { ...data }
                this.user = {
                    objectId: data.user.objectId,
                    name: data.user.name,
                    username: data.user.username
                }
                this.form.fieldMasks.phone = this.userCompany.profile?.phone
                this.form.isEdit = true
                this.form.loading = false
            }, (e) => {
                this.$helpers.requestError(e)
            })
        },
        async save (isEditing) {
            if (this.$refs.form.validate()) {
                this.form.valid = false
                if (isEditing) {
                    await this.saveUser(isEditing)
                    const userCompanySaved = await this.saveUserCompany(this.user, isEditing)
                    if (!userCompanySaved.hasOwnProperty('updatedAt')) {
                        alert(this.$t('portfolios.teamMember.form.errorUpdateAdmin'))
                        return
                    }
                    this.$router.go(-1)
                } else {
                    let userSaved = await this.saveUser(isEditing)
                    if (userSaved.hasOwnProperty('code') && userSaved.code === 202) {
                        userSaved = await this.getUserByEmail()
                    }
                    if (userSaved.hasOwnProperty('objectId')) {
                        const userCompanySaved = await this.saveUserCompany(userSaved, isEditing)
                        if (!userCompanySaved.hasOwnProperty('objectId')) {
                            alert(this.$t('portfolios.teamMember.form.errorRelation'))
                            return
                        }
                    } else {
                        alert(this.$t('portfolios.teamMember.form.errorCreate'))
                        return
                    }
                    this.$router.go(-1)
                }
            }
        },
        async saveUser (isEditing) {
            this.user.type = this.userCompany.permissions.isAdmin ? 'staff_admin' : 'staff'
            this.user.client = { __type: 'Pointer', className: 'Client', objectId: this.$route.params.requesterType }
            let endpoint = API.EndPoints.addUser
            if (isEditing) {
                endpoint = API.EndPoints.editUser
                endpoint.id = this.user.objectId
            } else {
                this.user.password = Math.random().toString(36).slice(-10)
            }
            return this.callApi(endpoint, JSON.stringify(this.user))
        },
        async saveUserCompany (user, isEditing) {
            if (this.form.inputAvatar.file) {
                if (this.form.inputAvatar.dirty) {
                    const avatarResponse = await this.uploadFile(this.form.inputAvatar.file)
                    if (avatarResponse.status === 201) {
                        const avatarObj = avatarResponse.body
                        this.userCompany.profile.avatar = {
                            name: avatarObj.name,
                            url: avatarObj.url,
                            __type: 'File'
                        }
                    }
                }
            } else {
                if (this.form.inputAvatar.dirty) {
                    delete this.userCompany.profile?.avatar
                }
            }

            this.userCompany.type = this.userCompany.permissions.isAdmin ? 'staff_admin' : 'staff'
            this.userCompany.user = { __type: 'Pointer', className: '_User', objectId: user.objectId }
            this.userCompany.client = { __type: 'Pointer', className: 'Client', objectId: this.$route.params.requesterType }
            this.userCompany.parent = { __type: 'Pointer', className: 'Client', objectId: this.$route.params.requesterType }
            this.userCompany.profile.phone = this.$helpers.unmask(this.form.fieldMasks.phone)
            this.userCompany.nameLowerCase = this.user.name.toLowerCase()
            let endpoint = API.EndPoints.addUserCompany
            if (isEditing) {
                endpoint = API.EndPoints.editUserCompany
                endpoint.id = this.userCompany.objectId
            }
            return this.callApi(endpoint, JSON.stringify(this.userCompany))
        },
        callApi (endpoint, params) {
            return new API(endpoint, params).request()
                .then((response) => {
                    return response.body
                }, (e) => {
                    return e.body
                })
        },
        uploadFile (file) {
            if (!file) return
            let endpoint = API.EndPoints.upload
            endpoint.filename = this.$helpers.normalizeFilename(file.name)
            return new API(endpoint, this.form.inputAvatar.file).request()
                .then(response => {
                    return response
                })
                .catch(() => { alert(this.$t('portfolios.teamMember.form.errorCreate')) })
        },
        getUserByEmail () {
            let endpoint = API.EndPoints.getUsers
            const params = {
                where: JSON.stringify({
                    username: this.user.username
                })
            }
            return new API(endpoint, params).request().then(response => {
                return Object.assign({}, response.body.results[0])
            }, (e) => {
                this.$helpers.requestError(e)
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
  .input-height
    height 57px
    position relative
</style>
